module.exports = __webpack_public_path__ + "static/media/emo1b.51b203e6.png";